import React from 'react'
import { connect } from 'react-redux'
import { store } from "../store"
import { push } from "react-router-redux"
import agent from '../agent'
import numberHelper from '../util/numberFormatter'
import Loading from './widgets/Loading'
import Header from './widgets/Header'
import { Link } from 'react-router-dom'
import Nav from './widgets/Nav'
import Util from '../util/util'
import ReactModal from 'react-modal'
import ListErrors from './widgets/ListErrors'
import GroupList from './widgets/GroupList'
import {
  GROUP_LIST_PAGE_LOADED,
  GROUP_LIST_PAGE_UNLOADED,
} from '../constants/actionTypes'
import _ from 'lodash'
import { Translation } from 'react-i18next'
import i18n from '../languages/lang.js'

const mapStateToProps = state => ({
  ...state.file,
  currentUser: state.common.currentUser,
  inProgress: state.common.inProgress
})

const mapDispatchToProps = dispatch => ({
  onLoad: (payload) => {
    dispatch({ type: GROUP_LIST_PAGE_LOADED, payload })
  },
  onUnload: () =>
    dispatch({ type: GROUP_LIST_PAGE_UNLOADED }),
})

class Groups extends React.Component {
  constructor() {
    super()
  }
  componentWillMount() {
    if (this.props.currentUser) {
      let payload = agent.Files.getGroups()
      this.props.onLoad(payload)
    }
  }

  componentWillReceiveProps(nextProps) {
  }

  componentWillUnmount() {
    this.props.onUnload()
  }
  render() {
    if (!this.props.groups) {
      return (
        <Loading selected={'groups'} currentUser={this.props.currentUser} />
      )
    }
    return (
      <Translation>
        {
          (t) => (
            <div id="main">
              <Nav selected={'groups'} currentUser={this.props.currentUser} />
              <div id="content">
                <Header />
                <div id="content-wrap">
                  <div className='box-header'>
                    <Link className='header-button' to='/groups/add'>{t('file.create_group_button')}</Link>
                    <h2>{t('file.group_list_title')}</h2>
                  </div>
                  <GroupList data={this.props.groups} />
                </div>
              </div>
            </div >
          )
        }
      </Translation>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Groups)
